<template>
  <div
    v-click-outside="closeDropdown"
    class="role-select"
  >
    <div class="select-wrapper">
      <label v-if="selectedFunction">Tipo de Perfil</label>

      <div
        class="selected-option"
        @click="toggleDropdown"
      >
        <span v-if="selectedFunction">
          <md-icon class="input-icon left">badge_outline</md-icon>
          {{ selectedFunction.label }}
        </span>
        <span
          v-else
          class="placeholder"
        >
          <md-icon class="input-icon left">badge_outline</md-icon>
          Tipo de Perfil
        </span>
        <i :class="{ 'arrow-up': isDropdownOpen, 'arrow-down': !isDropdownOpen }" />
      </div>
      <ul
        v-show="isDropdownOpen"
        class="dropdown-menu"
      >
        <li
          v-for="option in availableOptions"
          :key="option.label"
          @click="selectFunction(option)"
        >
          {{ option.label }}
        </li>
      </ul>
    </div>
    <div v-if="selectedFunction">
      <div class="role-select__info-box">
        <h5>
          {{ selectedFunction.roleName }}
        </h5>
        <p>
          {{ selectedFunction.roleDescription }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { clickOutside } from '@/utils/directives'
export default {
  name: 'UserRoleSelect',
  directives: {
    'click-outside': {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // here I check that click was outside the el and his children
          if (!(el === event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      },
    },
    clickOutside,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    clear: {
      type: Boolean,
      required: true,
    },
    canBeSuperUser: {
      type: Boolean,
    },
  },
  data() {
    return {
      isDropdownOpen: false,
      selectedFunction: this.value,
      options: [
        {
          role: 'PATERNITY',
          label: 'Paternidade',
          roleName: 'Função Paternidade',
          roleDescription:
            'O usuário terá acesso a todas as features, incluindo laudos de paternidade, exceto funcionalidades financeiras e gerenciamento de usuários.',
        },
        {
          role: 'FINANCIAL',
          label: 'Financeiro',
          roleName: 'Função financeiro',
          roleDescription:
            'O usuário poderá acessar a Guia de exames, boletos, notas fiscais e lista de preços dos exames.',
        },
        {
          role: 'OPERATOR',
          label: 'Operação',
          roleName: 'Função operação',
          roleDescription:
            'O usuário poderá cadastrar ordens de serviço, realizar recoletas e remarcações, conferir a rastreabilidade, pendências e fazer a impressão de etiquetas. Essa conta não terá acesso à dados financeiros.',
        },
        {
          role: 'ADMINISTRATOR',
          label: 'Administrador',
          roleName: 'Função Administração',
          roleDescription:
            'O usuário terá acesso a todas as features, editar e cadastrar outros usuários, exceto o Super Admin.',
        },
        {
          role: 'REGISTER',
          label: 'Cadastro',
          roleName: 'Função Cadastro',
          roleDescription:
            'O usuário terá acesso às funcionalidades de cadastro de ordens de serviço e pacientes.',
        },
        {
          role: 'SUPER_ADMIN',
          label: 'Super Admin',
          roleName: 'Função Administração',
          roleDescription:
            'O usuário terá acesso a todas as features, editar e cadastrar qualquer usuário.',
        },
      ],
    }
  },
  computed: {
    availableOptions() {
      return this.options.filter(option => {
        if (option.role === 'SUPER_ADMIN') {
          return this.canBeSuperUser
        }
        return true
      })
    },
    internalValue: {
      get() {
        return this.selectedFunction
      },
      set(option) {
        this.selectedFunction = option
        this.$emit('input', option.role)
      },
    },
  },
  watch: {
    value: {
      handler(newValue) {
        this.selectedFunction = this.options.find(option => option.role === newValue)
      },
      deep: true,
    },
    clear: {
      handler() {
        if (this.clear) {
          this.selectedFunction = ''
          this.isDropdownOpen = false
        }
      },
      deep: true,
    },
  },
  created() {
    this.selectedFunction = this.options.find(option => option.role === this.value)
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen
    },
    closeDropdown() {
      this.isDropdownOpen = false
    },
    selectFunction(option) {
      this.internalValue = option
      this.isDropdownOpen = false
    },
  },
}
</script>
<style lang="scss">
.role-select {
  .select-wrapper {
    position: relative;

    .arrow-up,
    .arrow-down {
      margin-right: 4px;
    }

    .arrow-up:before,
    .arrow-down:before {
      content: '';
      z-index: 11;
      display: block;
      width: 12px;
      height: 12px;
      border-top: 2px solid #818181;
      border-left: 2px solid #818181;
      transform: rotate(224deg);
      transition: all 0.3s ease-in-out;
      margin-top: -4px;
    }

    .arrow-up:before {
      margin-top: 6px;
      transform: rotate(45deg);
    }

    .dropdown-menu {
      position: absolute;
      top: calc(100% - 2px);
      left: -1px;
      width: calc(100% + 2px);
      background-color: #fff;
      border: 1px solid #ced4da;
      border-radius: 0 0 6px 6px;
      border-top: none;
      list-style: none;
      padding: 0;
      margin: 0;
      max-height: 200px;
      overflow-y: auto;
      z-index: 1080;

      li {
        padding: 10px;
        cursor: pointer;

        &:hover {
          background-color: #f8f9fa;
        }
      }
    }
  }
  &__info-box {
    padding: 16px 24px;
    background: #f1f5fe;
    border-radius: 6px;
    margin-top: 16px;
    color: #363636;

    h5 {
      font-size: 13.33px;
      font-weight: 700;
    }

    p {
      margin-top: 8px;
      font-size: 14px;
    }
  }
}
</style>
